export function searchResultsTypePatcher(data) {
    return {
        results: data.results.map(result => ({
            __typename: 'SearchResult',
            id: result.id,
            subtitle: result.subtitle,
            url: result.url,
            title: result.title,
            image: result.image,
            meta: result.meta,
            type: result.type,
        })),
    };
}
